import { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { trackEvent } from '@/lib/gtag';

const DISMISS_KEY = 'verdeia_dismissed_notif_banner';

export function NotificationBanner() {
  const { isSupported, isSubscribed, loading, subscribe, isIOSPWA } = usePushNotifications();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISS_KEY) === '1');
  }, []);

  const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

  // Hide if loading, already subscribed, or dismissed
  if (loading || isSubscribed || dismissed) return null;
  // Hide if iOS but not PWA (can't subscribe anyway, would only annoy)
  if (isIOS && !isIOSPWA) return null;
  // Hide on unsupported browsers
  if (!isSupported) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
    trackEvent('notif_banner_dismissed');
  };

  const handleEnable = async () => {
    trackEvent('notif_banner_enabled');
    const ok = await subscribe();
    if (ok) setDismissed(true);
  };

  return (
    <div className="px-4 pt-3">
      <div className="max-w-lg mx-auto flex items-center gap-3 p-3 rounded-xl bg-water/10 border border-water/30">
        <div className="w-9 h-9 rounded-lg bg-water/20 flex items-center justify-center flex-shrink-0">
          <Bell className="h-4 w-4 text-water" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground leading-tight">
            Ative os lembretes de rega
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Para não esquecer suas plantas
          </p>
        </div>
        <Button size="sm" onClick={handleEnable} className="h-8 px-3 text-xs">
          Ativar
        </Button>
        <button
          onClick={handleDismiss}
          className="p-1 text-muted-foreground hover:text-foreground"
          aria-label="Dispensar"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
